module.exports = __webpack_public_path__ + "static/media/kevin.fc16e83b.jpg";